"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnvironmentSelection = void 0;
var _react = require("react");
var _EnvironmentManager = require("../../EnvironmentManager.provider");
var _main = require("../../../../main");
var _EnvironmentManager2 = _interopRequireDefault(require("../../EnvironmentManager.styles"));
var _useTeacherApi = require("../../hooks/useTeacherApi");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EnvironmentSelection = props => {
  const styles = (0, _EnvironmentManager2.default)();
  const {
    selectedEnvironmentId,
    isLearingSite,
    onChange
  } = props;
  const {
    schoolTeachers,
    userEnvironments,
    getLabel,
    setPreloaderMode
  } = (0, _react.useContext)(_EnvironmentManager.EnvironmentManagerContext);
  const {
    getAudienceMembers
  } = (0, _useTeacherApi.useTeacherApi)(isLearingSite);
  const selectedEnvironmentOption = (0, _react.useRef)();
  const ongoingRequest = (0, _react.useRef)([]);
  const onEnvironmentChange = (0, _react.useCallback)(async selectedEnvId => {
    if (!selectedEnvId) {
      selectedEnvironmentOption.current = undefined;
      onChange();
      return;
    }
    if (ongoingRequest.current.includes(selectedEnvId)) {
      return; // Skip if a "getAudienceMembers" request for this environment is already in progress
    }
    setPreloaderMode('over');
    ongoingRequest.current.push(selectedEnvId);
    const selectedEnvInfo = userEnvironments?.find(env => env.Ids.Id === selectedEnvId);
    const audienceMembers = selectedEnvInfo?.Ids.Id ? await getAudienceMembers(selectedEnvInfo.Ids) : null;
    if (selectedEnvInfo?.Ids.Id) {
      selectedEnvironmentOption.current = {
        value: selectedEnvInfo?.Ids.Id,
        label: selectedEnvInfo?.Title
      };
      if (audienceMembers) {
        onChange({
          Ids: {
            Id: selectedEnvInfo?.Ids.Id,
            AudienceID: selectedEnvInfo?.Ids.AudienceID
          },
          Title: selectedEnvInfo.Title,
          Dates: {
            Start: selectedEnvInfo.Dates.Start,
            End: selectedEnvInfo.Dates.End
          },
          ProductInfo: {
            Languege: 'he',
            ProductId: selectedEnvInfo.ProductInfo.ProductId,
            ProductName: '',
            TopicId: selectedEnvInfo.ProductInfo.TopicId,
            TreeId: selectedEnvInfo.ProductInfo.TreeId,
            ProductURL: undefined,
            shareMessageLineText: undefined,
            defaultScoreType: 1
          },
          OwnerId: selectedEnvInfo.OwnerId,
          SchoolID: selectedEnvInfo.SchoolID,
          Teachers: (audienceMembers.teachers ?? []).map(teacherID => {
            const teacherInfo = schoolTeachers?.find(t => t.user?.id === teacherID);
            return {
              UserID: teacherID,
              UserName: teacherInfo?.user.fullName,
              ContextGroupID: teacherInfo?.user.contextGroupId
            };
          }),
          Audience: {
            Groups: (audienceMembers.groups ?? []).map(group => group.id),
            SingleStudents: audienceMembers.singleUsers ?? []
          },
          ScoreType: selectedEnvInfo.ScoreType,
          IsArchive: selectedEnvInfo.IsArchive
        });
      }
    }
    ongoingRequest.current = ongoingRequest.current.filter(e => e !== selectedEnvId);
    setPreloaderMode(undefined);
  }, [schoolTeachers, userEnvironments, setPreloaderMode, getAudienceMembers, onChange]);
  (0, _react.useEffect)(() => {
    if (userEnvironments?.length && selectedEnvironmentId !== selectedEnvironmentOption.current?.value) {
      onEnvironmentChange(selectedEnvironmentId);
    }
  }, [selectedEnvironmentId, userEnvironments, onEnvironmentChange]);
  const sortedEnvironmentOptions = (0, _react.useMemo)(() => userEnvironments?.map(env => {
    return {
      label: env.Title,
      value: env.Ids.Id
    };
  })?.sort((a, b) => a.label && b.label ? a.label.toString().localeCompare(b.label?.toString()) : 0) ?? [], [userEnvironments]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-EnvironmentManager_Row'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-EnvironmentManager_Cell_Label'],
      children: [getLabel('select_environment'), ":"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-EnvironmentManager_Cell_Content'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Select, {
        id: "environment",
        isMultiSelect: false,
        isWithFilter: true,
        btnLabel: selectedEnvironmentOption.current ? '' : getLabel('select'),
        value: selectedEnvironmentOption.current,
        filterPlaceholder: getLabel('search'),
        onChange: async option => {
          onEnvironmentChange(option.value.toString());
        },
        btnProps: {
          color: 'basic',
          customStyle: {
            width: '100%'
          },
          view: 'outlined'
        },
        options: sortedEnvironmentOptions
      })
    })]
  });
};
exports.EnvironmentSelection = EnvironmentSelection;